<template>
  <div class="filter__content">
    <form name="_form" action="" method="get" class="filter__form smartfilter">

      <div v-if="$route.path == '/search/' || $route.path == '/search_archive/'" class="filter__main-container global-search-preview">
        <div class="filter__row">
          <div class="filter__parametr">
            <input type="text" name="search" class="search__input" disabled="disabled"  :value="$route.query.q">
            <a href="javascript:void(0);" @click="changeGlobalSearch">изменить</a>
          </div>
        </div>
      </div>

      <div class="filter__main-container">
        <div class="filter__row">
          <div class="filter__parametr">
            <input type="text"
                   class="search__input"
                   name="query"
                   v-model="search"
                   placeholder="Введите ключевое слово"
                   @keyup="changeSearch()">
          </div>
        </div>
      </div>
      <div class="filter__row">
        <template v-if="user.isAuthorized">
          <div class="filter__parametr">
            <label class="filter__parametr-label">Цена в рублях</label>
            <div class="price-range">
              <div class="price-range__field-group">
                <input type="text"
                       v-model.number="selected.priceMin"
                       name="filterP1_MIN"
                       size="5"
                       class="price-range__input"
                       @change="changeFilter()">
                <input type="text"
                       v-model.number="selected.priceMax"
                       name="filterP1_MAX"
                       size="5"
                       class="price-range__input"
                       @change="changeFilter()">
              </div>
              <div id="ui-slider-price"
                   class="price-range__ui-slider noUi-target noUi-ltr noUi-horizontal">
                <div class="price-field">
                  <input type="range"
                         v-model.number="selected.priceMin"
                         :min="filters.PRICE.MIN"
                         :max="filters.PRICE.MAX"
                         id="lower"
                         @change="changeFilter()">
                  <input type="range"
                         v-model.number="selected.priceMax"
                         :min="filters.PRICE.MIN"
                         :max="filters.PRICE.MAX"
                         id="upper"
                         @change="changeFilter()">
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="filter__parametr">
          <label class="filter__parametr-label">Спецпредложения</label>
          <label class="checkbox">
            <input v-model="selected.khitprodazh" type="checkbox" class="checkbox__input" name="khitprodazh"
                   id="khitprodazh" @change="changeFilter()">
            <span class="checkbox__value">Лидер продаж</span>
          </label><br/><br/>
          <!--<label class="checkbox">
            <input v-model="selected.aktsii" type="checkbox" class="checkbox__input" name="sales"
                   id="sales" @change="changeFilter()">
            <span class="checkbox__value">Акция</span>
          </label><br/><br/>-->
          <label class="checkbox">
            <input v-model="selected.novinki" type="checkbox" class="checkbox__input" name="new"
                   id="new" @change="changeFilter()">
            <span class="checkbox__value">Новинка</span>
          </label>
        </div>
        <div class="filter__parametr">
          <label class="filter__parametr-label">Торговая марка</label>
          <div class="select">
            <template v-if="filters.TORGOVAYA_MARKA.length > 0">
              <v-select multiple
                        v-model="selected.torgovayaMarka"
                        :options="filters.TORGOVAYA_MARKA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div class="filter__parametr">
          <label class="filter__parametr-label">Раздел</label>
          <div class="select">
            <template v-if="filters.CATALOG_FOLDER.length > 0">
              <v-select multiple
                        v-model="selected.catalogFolder"
                        :options="filters.CATALOG_FOLDER"
                        :reduce="(option) => option.code"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div class="filter__parametr" >
          <label class="filter__parametr-label">Вид упаковки</label>
          <div class="select">
            <template v-if="filters.VID_UPAKOVKI.length > 0">
              <v-select multiple
                        v-model="selected.vidUpakovki"
                        :options="filters.VID_UPAKOVKI"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div class="filter__parametr">
          <label class="filter__parametr-label">Материал</label>
          <div class="select">
            <template v-if="filters.MATERIAL.length > 0">
              <v-select multiple
                        v-model="selected.material"
                        :options="filters.MATERIAL"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div class="filter__parametr" >
          <label class="filter__parametr-label">Сезонность</label>
          <div class="select">
            <template v-if="filters.SEZONNOST.length > 0">
              <v-select multiple
                        v-model="selected.sezonnost"
                        :options="filters.SEZONNOST"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.PLOTNOST_BUMAGI.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Плотность бумаги</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.plotnost"
                        :options="filters.PLOTNOST_BUMAGI"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.RAZMER_PAKETA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Размер пакета</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.razmerPaketa"
                        :options="filters.RAZMER_PAKETA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.ASSORTIMENTNAYA_LINEYKA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Ассортиментная линейка</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.assortimentnayLineyka"
                        :options="filters.ASSORTIMENTNAYA_LINEYKA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.KONTSEPT.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Концепт</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.konsept"
                        :options="filters.KONTSEPT"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.SERIYA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Серия</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.seriya"
                        :options="filters.SERIYA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.BATAREYKI.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Батарейки</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.batareyki"
                        :options="filters.BATAREYKI"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.ZVUK.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Звук</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.zvuk"
                        :options="filters.ZVUK"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.KLASS.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Класс</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.klass"
                        :options="filters.KLASS"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.TIP_MEKHANIZMA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Тип механизма</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.tip_m"
                        :options="filters.TIP_MEKHANIZMA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.PODKATEGORIYA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Подкатегория</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.podkategoriya"
                        :options="filters.PODKATEGORIYA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.PROFIL.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Профиль</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.profil"
                        :options="filters.PROFIL"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.SVET.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Свет</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.svet"
                        :options="filters.SVET"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.TIP_IZDELIYA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Тип изделия</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.tip_izdeliya"
                        :options="filters.TIP_IZDELIYA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="filters.TIP_KUZOVA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Тип кузова</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.tip_kuzova"
                        :options="filters.TIP_KUZOVA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>
        <div v-if="filters.BOITSYA_KHOLODA.length > 0" class="filter__parametr">
          <label class="filter__parametr-label">Боится Холода</label>
          <div class="select">
            <template >
              <v-select multiple
                        v-model="selected.boitsya_kholoda"
                        :options="filters.BOITSYA_KHOLODA"
                        :reduce="(option) => option.label"
                        @input="changeFilter"></v-select>
            </template>
          </div>
        </div>

        <div v-if="path != '/search/' && path != '/search_archive/'"
            class="filter__parametr filter__parametr_checkbox">
          <label class="checkbox">
            <input v-model="showTransitStorage" type="checkbox" value="Y" class="checkbox__input" name="show_transit"
                   id="show_transit"
                   @change="changeFilter()">
            <span class="checkbox__value">Товары из транзита</span>
          </label>
        </div>
      </div>

      <div class="filter__full-container">
        <div class="filter__row">
          <div class="filter__parametr">
            <label class="filter__parametr-label">Акции</label>
            <div class="select">
              <template v-if="filters.FLAG.length > 0">
                <v-select multiple
                          v-model="selected.action"
                          :options="filters.FLAG"
                          :reduce="(option) => option.code"
                          @input="changeFilter"></v-select>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="filter__full-container">
        <div class="filter__row">
          <div class="filter__parametr">
            <label class="filter__parametr-label">Страна</label>
            <div class="select">
              <template v-if="filters.STRANA_PROIZVODITEL.length > 0">
                <v-select multiple
                          v-model="selected.proizvoditel"
                          :options="filters.STRANA_PROIZVODITEL"
                          :reduce="(option) => option.label"
                          @input="changeFilter"></v-select>
              </template>
            </div>
          </div>
          <div class="filter__parametr">
            <label class="filter__parametr-label">Лицензия</label>
            <div class="select">
              <template v-if="filters.LITSENZIYA.length > 0">
                <v-select multiple
                          v-model="selected.litsenziya"
                          :options="filters.LITSENZIYA"
                          :reduce="(option) => option.label"
                          @input="changeFilter"></v-select>
              </template>
            </div>
          </div>
<!--          <div class="filter__parametr">
            <label class="filter__parametr-label">В наличии</label>
            <div class="select">
              <select v-model="selected.gdeostatok"
                      class="filter-select select__input selected.gdeostatok"
                      @change="changeFilter()">
                <option value="all" selected>Все</option>
                <option v-for="(value, key) in filters.GDEOSTATOK" :value="value">{{ value }}</option>
              </select>
            </div>
          </div>-->
         <!-- <div class="filter__parametr filter__parametr_checkbox">
            <label class="checkbox">
              <input v-model="selected.khitprodazh" type="checkbox" class="checkbox__input" name="khitprodazh"
                     id="khitprodazh"
                     @change="changeFilter()">
              <span class="checkbox__value">Лидер продаж</span>
            </label>
          </div>-->
          <div class="loader-mini" :class="{'active': isLoading}"></div>
        </div>
      </div>
      <input type="text" id="del_filter" name="del_filter" value="очистить" style="display:none">
      <input type="text" id="modef" name="modef" value="" style="display:none">
      <input type="text" id="modef_num" name="modef_num" value="" style="display:none">
    </form>
  </div>
</template>

<script>
export default {
  name: "FilterBox",
  data: function () {
    return {
      searchQuery: '',
      selected: {
        priceMin: 0,
        priceMax: 10000,
        torgovayaMarka: '',
        catalogFolder: '',
        vidUpakovki: '',
        material: '',
        sezonnost: '',
        stranaProizvoditel: '',
        litsenziya: '',
        khitprodazh: this.$route.query.khitprodazh == '1' ? 1 : 0,
        novinki: this.$route.query.novinki == '1' ? 1 : 0,
        aktsii: 0,
        gdeostatok: '',
        plotnost: '',
        action: '',
        razmerPaketa: '',
        assortimentnayLineyka: '',
        konsept: '',
        seriya: '',
        batareyki: '',
        zvuk: '',
        klass: '',
        tip_m: '',
        podkategoriya: '',
        profil: '',
        svet: '',
        tip_izdeliya: '',
        tip_kuzova: '',
        boitsya_kholoda: '',
      },
      showTransitStorage: this.$store.getters.settings.filter.isTransitStorage,
      search: '',
      viewMode: 'product_view_list',
      btnExtText: 'Расширенный фильтр',
      user: {
        isAuthorized: false
      },
      filters: {
        CATALOG_FOLDER: [],
        TORGOVAYA_MARKA: [],
        RAZMER_PAKETA: [],
        VID_UPAKOVKI: [],
        MATERIAL: [],
        SEZONNOST: [],
        STRANA_PROIZVODITEL: [],
        LITSENZIYA: [],
        KHITPRODAZH: [],
        GDEOSTATOK: [],
        PLOTNOST_BUMAGI: [],
        ASSORTIMENTNAYA_LINEYKA: [],
        KONTSEPT: [],
        SERIYA: [],
        BATAREYKI: [],
        ZVUK: [],
        KLASS: [],

        TIP_MEKHANIZMA: [],
        PODKATEGORIYA: [],
        PROFIL: [],
        SVET: [],
        TIP_IZDELIYA: [],
        TIP_KUZOVA: [],
        BOITSYA_KHOLODA: [],

        FLAG: [],
        PRICE: {
          MIN: 0,
          MAX: 10000
        }
      },
      timerId: 0,
      isLoading: false,
    }
  },
  computed: {
    page() {
      return this.$store.getters.page;
    },
    path() {
      return this.$route.path;
    }
  },
  watch: {
    page: function (val) {
      if ('filter' in val && typeof (val.filter) == 'object') {
        this.selected.priceMax = val.filter.PRICE.MAX;
        this.selected.priceMin = val.filter.PRICE.MIN;
        this.filters = val.filter;
      }
      this.user = val.user;
      this.isLoading = false;
    },
  },
  methods: {
    changeGlobalSearch: function(){
      if(!$(".js-search-btn-mobile").parent().hasClass('open')){
        $(".js-search-btn-mobile").parent().toggleClass("open")
      }
      window.scrollTo({ top: 0});
      setTimeout(function () {
       document.getElementById("inputSearch").focus();
      }, 50);
    },

    changeSearch: function () {
      let vm = this;

      this.isLoading = true;
      clearTimeout(this.timerId);
      this.timerId = setTimeout(function () {
        vm.changeFilter();
        vm.isLoading = false;
      }, 500);
    },
    changeFilter: function () {
      this.isLoading = true;
      this.$store.dispatch('SET_SETTINGS', {
        page: {
          current: 1,
          perPage: this.page.page.perPage
        },
        filter: {
          filters: this.selected,
          isTransitStorage: this.showTransitStorage,
          search: this.search
        }
      });
      this.$store.dispatch('UPDATE_STORE');

      if (this.showTransitStorage) {
        this.$cookies.set("showTransitStorage", this.showTransitStorage);
      } else {
        $cookies.remove("showTransitStorage");
      }
    },
  },
}
</script>

<style>
  .v-select, .v-select * {
    background: white;
    border-radius: 3px;
  }
  .vs--searchable .vs__dropdown-toggle, .vs--searchable .vs__dropdown-menu {
    border: none
  }

  .filter__form .global-search-preview{
      display: none;
  }

  .filter__form .global-search-preview .filter__parametr{
      position: relative;
  }
  .filter__form .global-search-preview .search__input{
      opacity: 0.6;
  }
  .filter__form .global-search-preview a{
    position: absolute;
    right: 12px;
    top: 12px;
  }

  @media screen and (max-width: 767px) {
    .filter__form .global-search-preview{
      display: block;
    }
  }

</style>